export const inferErrorCode = (message: string, fallback = 500) => {
  const normalized = String(message || '').toLowerCase()
  const explicit = normalized.match(/\b([45]\d{2})\b/)
  if (explicit) {
    const code = Number(explicit[1])
    if (Number.isInteger(code) && code >= 400 && code <= 599) return code
  }
  if (normalized.includes('non autoriz')) return 401
  if (normalized.includes('token mancante')) return 401
  if (normalized.includes('permess')) return 403
  if (normalized.includes('non pubblicato')) return 403
  if (normalized.includes('non trovat')) return 404
  if (normalized.includes('timeout')) return 504
  if (normalized.includes('non raggiungibile')) return 503
  return fallback
}
